export default __webpack_public_path__ + "static/media/Shape.724a2d51.svg";